export default {"src":"/_next/static/media/telegram.d45fd9dc.svg","height":16,"width":16};